import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=6754d58b&scoped=true"
import script from "./Period.vue?vue&type=script&lang=js"
export * from "./Period.vue?vue&type=script&lang=js"
import style0 from "./Period.vue?vue&type=style&index=0&id=6754d58b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754d58b",
  null
  
)

export default component.exports